import { StaticDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.static";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { EMPTY_DECOMPOSITION_MAP, loadDecompositionMap } from "#decomposition-map";

export function useGetDecompositionMapQueryKey() {
  const [staticDb] = useContextSelectors(StaticDatabaseContext, (c) => c.db);
  return (roots?: readonly string[]) => ["decompositionMap", { staticDb }, roots] as const;
}

/**
 * Decomposition-map query options bound to the active static database. When rendered outside a
 * `StaticDatabaseContext` provider (e.g. leaf UI tests), the resolved `staticDb` is `undefined`
 * and the consumer reads back the empty-map fallback.
 *
 * The static shard is immutable for the life of a database instance, so the key carries no table
 * change version: the map loads once per static database and is shared by every consumer (the
 * decomposition panel and the review-queue scheduler alike).
 */
export const [useDecompositionMapQueryOptions, decompositionMapQueryFn] = createUseQueryOptions(
  useGetDecompositionMapQueryKey,
  ({ queryKey: [_, { staticDb }, roots] }) => {
    if (staticDb === undefined) {
      return EMPTY_DECOMPOSITION_MAP;
    }
    return loadDecompositionMap(staticDb, roots);
  },
);
